import { checkPermission } from '@/utils/permission'

const permissionDirective = {
  inserted(el, binding) {
    const permission = binding.value
    if (permission && !checkPermission(permission)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export function setupPermissionDirective(Vue) {
  Vue.directive('permission', permissionDirective)
}

export default permissionDirective
